import questions from "../../assets/js/helpMultilngual/bs_questions";
import troubles from "../../assets/js/helpMultilngual/bs_troubles";
const cn = {
  language: "中文",
  bstext: {
    bs1: "换电套餐",
    bs2: "套餐详情",
    bs3: "使用说明",
    bs4: "我要开通",
    bs5: "下一步",
    bs6: "确认变更",
    bs7: "套餐变更",
    bs8: "换电套餐",
    bs9: "变更成功",
    bs10: "开通成功",
    bs11:
      "请尽快在蓝鲨线下门店进行激活，即可使用换电功能。激活后如需取消，请至线下服务网点进行办理。",
    bs12: "{msg}秒后返回",
    bs13: "历史账单",
    bs14: "待支付",
    bs15: "您当前暂无账单信息",
    bs16: "年",
    bs17: "{msg}月账单",
    bs18: "{msg}月账单金额",
    bs19: "套餐费用",
    bs20: "单电套餐",
    bs21: "双电套餐",
    bs22: "换电费用",
    bs23: "本月付费换电量", //文案修改
    bs24: "安时",
    bs25: "变更费用",
    bs26: "升级费用",
    bs27: "支付时间",
    bs28: "支付方式",
    bs29: "资费说明",
    bs30: "账单费用=套餐费用+换电费用+变更费用",
    bs31: "套餐费用=月套餐固定费用(不足一天按天折算)",
    bs32: "换电费用=周期内付费换电总安时*2元",
    bs33: "变更费用=超3个月升级费用",
    bs34: "去支付",
    bs35: "已出账单",
    bs36: "暂无",
    bs37: "未出账单",
    bs38: "至今",
    bs39: "未出账",
    bs40: "出账日",
    bs41: "最后付款日",
    bs42: "为保证正常使用，请尽快付款",
    bs43: "暂无账单信息",
    bs44: "我的账单",
    bs45: "开通",
    bs46: "您尚未开通换电套餐",
    bs47: "我的套餐",
    bs48: "请选择想要变更的套餐",
    bs49: "开通时间",
    bs50: "激活时间",
    bs51: "关闭时间",
    bs52: "变更时间",
    bs53: "取消套餐",
    bs54:
      "您的原套餐已使用超过3个月，如转换需要缴纳3000台币的运营费用，费用将统计至本月账单，请确认后转换。",
    bs55: "我再想想",
    bs56: "我已知晓，确认变更",
    bs57: "是否确认取消？",
    bs58: "取消",
    bs59: "确认",
    bs60: "我的套餐",
    bs61: "你已取消换电套餐【{msg}】",
    bs62:
      "您的原套餐已使用超过3个月，如转换需要缴纳3000台币的运营费用，费用将统计至本月账单。",
    bs63: "信息确认",
    bs64:
      "您申请变更为{name}套餐，将于次日生效，变更后本月账单将按照两个套餐实际使用天数计算。请确认！",
    bs65: "应付金额",
    bs66: "请选择付款方式",
    bs67: "支付",
    bs68: "错误码:",
    bs69: "完成",
    bs70: "重新支付",
    bs71: "取消支付",
    bs72: "加载中",
    bs73: "支付成功",
    bs74: "支付失败",
    bs75: "页面跳转中"
  },
  bsstatus: {
    // 结算周期
    cycles: [
      {
        key: 1,
        val: "月"
      }
    ],
    // 套餐状态
    menus: [
      {
        key: "1",
        val: "未激活"
      },
      {
        key: "2",
        val: "使用中"
      },
      {
        key: "3",
        val: "已变更"
      },
      {
        key: "4",
        val: "已关闭"
      }
    ],
    // 支付方式
    payMethods: [
      {
        key: "CARD",
        val: "Credit Card"
      },
      {
        key: "BANK",
        val: "Bank Transfer"
      },
      {
        key: "VBANK",
        val: "Virtual Account"
      }
    ],
    // 支付状态
    payStatuss: [
      {
        key: "1",
        val: "待支付"
      },
      {
        key: "2",
        val: "已支付"
      },
      {
        key: "3",
        val: "已逾期"
      },
      {
        key: "4",
        val: "未出账"
      }
    ]
  },
  helpCenter: {
    documentTitle: "帮助中心",
    title: [
      "绑定激活",
      "账号问题",
      "驾驶出行",
      "ADAS安全辅助",
      "信息娱乐",
      "APP使用问题",
      "车辆升级",
      "用电安全",
      "车辆保养",
      "故障自检"
    ],
    description: "故障详情描述：",
    solution: "处理意见：",
    exAssistance: "换电帮助",
    exAssistanceList: [
      "关于蓝鲨智能换电服务",
      "关于换电账号",
      "关于换电套餐",
      "关于如何使用换电服务"
    ],
    exAssistanceSubtitle: [
      ["关于蓝鲨智能换电服务"],
      ["如何获取换电账号？", "换电账号有哪些用途？"],
      [
        "什么是换电套餐？",
        "当月额度有剩余，剩余的额度可以转到下月使用吗？",
        "购买后的换电套餐可以退款吗？",
        "购买后的换电套餐可以续费吗？",
        "换电套餐的生效日规则"
      ],
      [
        "购买完套餐后，首次换电要如何操作？",
        "如何操作换电？",
        "如何查询各个换电柜站点的电池信息情况？",
        "造成换电失败可能的原因有哪些？"
      ]
    ],
    exAssistanceInfo: [
      [
        [
          "蓝鲨智能换电服务，是蓝鲨针对特定的需求市场提供的快捷补能服务，包括铺设换电柜、提供电池租赁服务、换电服务功能等，可有效解决电动摩托车续航能力不足的劣势，最快实现3秒完成补能换电。",
          "由于各个市场的需求情况的差异性，蓝鲨智能换电服务不完全覆盖蓝鲨车辆的销售区域，部分车辆销售区域，不提供相关的换电补能服务，具体情况，可咨询当地的销售门店或者经销商。"
        ]
      ],
      [
        [
          "如果您所在的区域开通了蓝鲨智能换电服务，首先您需要下载Blueshark app并成功注册一个app账号。在app的首页会找到“换电服务”的功能卡片。",
          "选择“换电服务”功能卡片，选择合适的换电运营商，阅读并同意《换电服务协议》，即可完成换电账号的创建。",
          "如果您所在的区域尚未开通蓝鲨智能换电服务，则无法访问“换电服务”功能卡片，且无法创建换电账号。"
        ],
        [
          "换电账号是使用蓝鲨智能换电服务的唯一身份账号，如果没有换电账号，则无法享用换电服务的权益。换电账号可以用来购买换电套餐，换电换电服务，对换电额度及资产进行管理，对换电记录及消费进行管理等。"
        ]
      ],
      [
        [
          "换电套餐是由各个开展换电服务的换电运营商，根据各地的换电业务需求，自主进行套餐规则制定、套餐价格制定的虚拟权益的电子商品。",
          "目前套餐规则支持按用电量计费、按换电次数计费以及无限制换电额度三种计费方式，额度按月分配，费用结算的方式可月结、季节、年结。具体的可选套餐，以所选的运营商的实际制定规则为准。",
          "完成换电套餐的购买，即可享有换电服务权益，可前往线下门店或经销商，领取换电服务权益，进而使用换电服务。"
        ],
        [
          "按目前换电服务规则，如当月有未使用完的额度，进入下个月结算周期时清零，不累计到下个月。请根据实际的用电需求，选择适合日常使用需求的换电套餐。"
        ],
        [
          "换电套餐是虚拟权益的电子商品，根据换电使用规则是无法退款的，建议您评估后进行购买，避免损失，感谢您的理解。"
        ],
        [
          "在您购买换电套餐时，请关注换电套餐的续费规则，在满足续费规则的前提下，均是可以续费的，续费后换电权益会在“我的换电”页面不断累计。请您根据实际需要，合理购买和续费。"
        ],
        [
          "换电套餐购买后，次月1日生效。请注意，若需要当即生效，需要勾选“当月生效”选项，并补足当月生效的套餐额度，即可实现换电套餐的当即生效。请在购买换电套餐时，合理的根据个人需要，计划换电套餐的启用时间。"
        ]
      ],
      [
        [
          "购买完换电套餐，首先需要根据app的引导，前往线下门店或经销商网点，领取换电服务权益并登记电池。如果电池为租赁电池，需前往线下门店或经销商网点，租赁电池并缴纳电池租赁押金。",
          "登记后的电池即享有换电服务权益，即可将电池插入换电柜，换电柜会自动弹出满电或者是高电量电池，并将换电服务权益，捆绑至新弹出的电池上。"
        ],
        [
          "用户完成首次换电电池登记后，后续的每次换电，仅需要将低电量电池插入换电柜空仓，换电柜会自动将满电或者是高电量电池弹出。",
          "若换电柜未正常弹出电池，根据换电柜屏幕提示的内容，联系人工客服处理。"
        ],
        [
          "您可以选择Blueshark app的换电服务卡片，换电地图首页，查询到附近的换电柜信息，包括换电柜的名称、位置、距离您的距离、电池情况的概览等，点击换电柜，进入换电柜详情页，即可查看所选换电柜的电池信息情况。"
        ],
        [
          "造成换电失败的原因，可能有以下几种情况：",
          "①插入的电池换电服务已到期，导致无法正常换电，请先续费后再使用；",
          "②换电柜内无可换电池，即换电柜内的电池电量都不满足换电条件，导致无法换电，可前往其他换电柜进行换电；",
          "③如上述情况均正常，多次尝试换电均无法成功换电时，请联系人工客户解决。"
        ]
      ]
    ],
    quickGuide: "车辆快速上手指南",
    quickGuideList: [
      "基本操作",
      "车辆激活",
      "驻车功能",
      "行车功能",
      "骑行与挡位"
    ],
    QuickListSubtitle: [
      ["H1 2023基本操作", "R1 2023基本操作"],
      ["H1 2023车辆激活", "R1 2023车辆激活"],
      ["H1 2023驻车功能", "R1 2023驻车功能"],
      ["H1 2023行车功能", "R1 2023行车功能"],
      ["H1 2023骑行与挡位", "R1 2023骑行与挡位"]
    ],
    h1Node:
      "注：本指南仅适用 H1 2023，H1 lite请参照说明书使用，本指南内容仅支持快速上手使用，详细的操作请参见说明书。",
    r1Node:
      "注：本指南仅适用 R1 2023，R1 lite请参照说明书使用，本指南内容仅支持快速上手使用，详细的操作请参见说明书。",
    lightDescription: "指示灯说明",
    signalLeft: "左转向灯",
    signalRight: "右转向灯",
    highBeam: "远光灯",
    lowBeam: "近光灯",
    lowPowerLight: "低电量提示灯",
    faultLight: "故障提示灯",
    readyLight: "准备状态指示灯",
    instrumentPic: "仪表平面示意图",
    leftKeyDescription: "按键说明（左手把）",
    leftHandPic: "左手把示意图",
    rightKeyDescription: "按键说明（右手把）",
    rightHandPic: "右手把示意图",
    overtakingLightKey: "超车灯键：拨动灯光会闪烁",
    lowBeanKey: "近光灯键：拨动开启近光灯",
    highBeamKey: "远光灯键：拨动开启远光灯",
    configKey: "确认键：用于智能卡片内的确认操作",
    smartKey: "智能键：用于多功能卡片内的切换及卡片的控制",
    LeftTrunSignalKey: "转向灯键：向左拨动开启左转向灯，向中间按压关闭转向灯",
    RightTrunSignalKey: "转向灯键：向右拨动开启右转向灯，向中间按压关闭转向灯",
    hornKey: "喇叭键：用手按住鸣笛，松开鸣笛结束",
    cruiseControlKey:
      "定速巡航键：短按开启定速巡航（车速大于15km/h），再次短按或刹车关闭定速巡航",
    waringKey: "危险警示灯键：当车辆出现故障或发生紧急状况时，按下开启双闪",
    costomKey: "自定义按键：内容待补充",
    turboKey: "TURBO键：短按进入TURBO挡，再次短按退出TURBO挡",
    sportKey: "SPORT键：短按进入SPORT挡，再次短按退出SPORT挡",
    openSeatKey: "开坐桶键：当车辆处于通电状态下，短按开启坐桶",
    transferAssistanceKey:
      "移车助力键：当车辆处于骑行状态且静止时，短按 MAM键进入移车助力挡位，此时拨动「M」或转动转把可操作车辆前后缓速移动。",
    gearKey: "挡位键：短按切换挡位",
    LeftGearKey: "挡位键：向左拨动降挡",
    RightGearKey: "挡位键：向右拨动升挡",
    volumeIncreaseKey: "音量调节键：短按右侧键增加音量",
    volumedecreaseKey: "音量调节键：短按左侧键降低音量",
    readyKey: "Ready键：短按即可切换行车或驻车模式",
    activationNode:
      "注：新车交付时，车辆属于未激活状态，需要激活后使用完整的功能及服务",
    activeCardPic: "车辆激活卡片图示",
    activeUIPic: "车辆激活界面图示",
    activeStep1: "第一步：首次开机页面",
    activeStep2: "第二步：App下载引导页",
    activeStep3: "第三步：激活页操作引导页",
    activeStep4: "第四步：激活结果页",
    activeStepInfo1: "当车辆出现此卡片时，短按",
    activeStepInfo2: "进入激活的流程",
    activeStepInfo3:
      "可以在安卓/苹果市场下载【蓝鲨】App；如已经下载，可以直接短按",
    activeStepInfo5: "切换下一步",
    activeStepInfo6:
      "按照App提示搜索车辆，找到对应车辆后，输入车辆仪表上显示的4位Pin码完成激活",
    activeStepInfo7:
      "激活成功后跳转至激活成功页（注意，需要在5分钟内完成此操作，否则将会重新开始激活的流程）",
    instrumentDescription: "仪表整体说明",
    instrumentStopPic: "仪表（驻车状态）示意图 ",
    instrumentWorkPic: "仪表（行车状态）示意图",
    cardPic: "聚合卡片图示",
    instrumentInfo1:
      "智能卡片区（包含聚合卡片、骑行统计、蓝牙音乐、蓝牙设置、车辆健康、车辆设置）",
    instrumentInfo2: "中间信息区（包含车辆健康状态、车辆行驶统计）",
    instrumentInfo3: "车辆信息区（包含车辆挡位、续航信息、功能开启状态）",
    aggregatedCardArea: "智能卡片区—聚合卡片",
    aggregatedCardInfo1:
      "显示蓝牙音乐的播放状态，可以根据音乐功能内的提示文案判断音乐功能的状态",
    aggregatedCardInfo2:
      "显示蓝牙的连接状态，未连接时，图标颜色为灰色，连接成功时，图标颜色为彩色",
    aggregatedCardInfo3:
      "显示行车记录仪的开闭状态，未开启时，图标颜色为灰色，开启时，图标颜色为彩色",
    aggregatedCardInfo4: "功能暂未开放,敬请期待",
    cyclingStatistics: "智能卡片区—骑行统计",
    cyclingPic: "骑行统计图示",
    cyclingStatisticsInfo1: "此处显示了车辆的总行驶里程，自出厂开始统计",
    cyclingStatisticsInfo2: "此处显示了您某一次的行驶里程，可以短按",
    cyclingStatisticsInfo3: "重置此数据",
    BluetoothMusic: "智能卡片区—蓝牙音乐",
    BluetoothPic: "蓝牙音乐图示",
    BluetoothMusicInfo1:
      "有音频时此处显示歌手及歌词的名称，无音频时此处显示【未知歌曲】（需要连接蓝牙后通过移动设备播放音频）",
    BluetoothMusicInfo2: "短按",
    BluetoothMusicInfo3: "控制播放音乐/暂停音乐",
    BluetoothMusicInfo4: "长按",
    BluetoothMusicInfo5: "切换下一曲",
    vehicleHealth: "智能卡片区—车辆健康",
    healthPic: "车辆健康图示",
    warningPic: "车辆异常图示",
    vehicleHealthInfo1:
      "启动车辆后，切换至此卡片，它会自动对车辆健康状况进行检测",
    vehicleHealthInfo2:
      "当车辆健康状况出现问题时，卡片内会显示相应的故障信息，可以通过短按",
    vehicleHealthInfo3: "键查看故障的详细信息",
    vehicleSetting: "智能卡片区—车辆设置",
    settingPic: "车辆设置图示",
    vehicleSettingInfo1:
      "此功能可以针对车辆进行设置（包含的设置项：蓝牙音量、摩托音、显示模式、车辆版本、语言设置、行车记录仪、恢复出厂设置、安全辅助、待绑定模式、距离单位、时间单位）",
    vehicleSettingInfo2: "想要切换不同的功能时，可以短按",
    vehicleSettingInfo3: "来控制",
    vehicleSettingInfo4: "找到自己需要的功能想要确认时，可以短按",
    vehicleSettingInfo5: "来进行确认",
    instrumentWorkingInfo1: "智能卡片区（包含聚合卡片、骑行统计、蓝牙音乐）",
    instrumentWorkingInfo2: "中间信息区（包含车辆实时速度、电池信息）",
    instrumentWorkingInfo3:
      "车辆信息区（包含车辆挡位、续航信息、实时电流、实时能耗）",
    aggregatedCardWorkingInfo2: "显示本次骑行数据",
    startCycling: "开始骑行",
    startInfo:
      "短按【Ready】键，进入或退出骑行模式，仪表显示对应画面（详见下图）",
    gearShift: "挡位切换",
    gearNote:
      "注：车辆一共有五个挡位，分别是【ECO】【COMFORT】【SPORT】【TURBO】【MAM】",
    H1GearNote:
      "注：车辆一共有四个挡位，分别是【ECO】【COMFORT】【SPORT】【MAM】",
    gearInfo1: "ECO挡位适合节能驾驶时使用，可以提供最长的续航",
    gearInfo2: "COMFORT挡位适合日常驾驶时使用，平衡续航，加速，极速",
    gearInfo3: "SPORT挡位适合运动驾驶时使用，突出超车性能，极速性能",
    gearInfo4: "Turbo挡位适合激烈驾驶时使用，释放车辆所有性能",
    gearInfo5: "MAM挡位适合推车/挪车时使用",
    gearInfo6: "向左或向右拨动M键进行切换挡位",
    gearInfo7: "短按Turbo键进入Turbo挡",
    gearInfo8:
      "长按此按键进入MAM挡位，此时可以拧动转把或拨动M-/M+来控制车辆移动（M-倒车；M+前进）",
    gearInfo9: "按 M 键进行切换挡位",
    gearInfo10:
      "长按此按键进入MAM挡位，此时可以按下M-/M+来控制车辆移动（M-倒车；M+前进）",
    drivingPage: "行车页面",
    parkingPage: "驻车页面",
    gearPic: "挡位信息显示区域图",
    troubles,
    questions
  }
};

export default cn;



// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js